module.exports = __webpack_public_path__ + "static/img/dn2-mayor.1c10a15.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dn2-mayor.png
// module id = eIDL
// module chunks = 0